import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useField } from 'formik';
import { Stack } from '@koob/margaret';
import { FormField, ErrorMessageWrapper, FormLabel } from 'ui/forms';
import { KoobAvatar, KoobButton } from '@koob/ui';

const AvatarField = ({
  label,
  name,
  url,
  shape,
  forImage,
  placeholder,
  disabled,
  testId,
  accept = 'image/*',
  ...props
}) => {
  const [imageUrl, setImageUrl] = useState();
  const [{ value }, { touched, error }, { setValue, setTouched }] = useField({
    name,
  });
  const hasError = Boolean(touched) && Boolean(error);
  const theme = useTheme();
  const { t } = useTranslation('misc');

  const handleLoadFile = (e) => {
    setTouched(true);
    const reader = new FileReader();
    const [file] = e.target.files;
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setImageUrl(reader.result);
      const imageUrl = reader.result;
      setValue({
        file,
        displayName: file.name,
        isMainPicture: true,
        imageUrl,
      });
    };
  };

  const handleReset = () => {
    setValue(null);
    setImageUrl(null);
  };

  useEffect(() => {
    setImageUrl(url);
  }, [url]);

  return (
    <FormField>
      <Stack gutterSize={0.5}>
        <Stack>
          {shape === 'square' ? (
            <div className="flex h-48 w-[250px] items-center justify-center overflow-hidden rounded-2xl bg-navy-50 text-navy-400">
              {imageUrl ? (
                <img
                  src={imageUrl}
                  alt=""
                  className="h-full w-full object-cover"
                />
              ) : (
                placeholder
              )}
            </div>
          ) : (
            <KoobAvatar
              src={imageUrl}
              icon={placeholder}
              size={16}
              rounded="full"
            />
          )}
        </Stack>
        {!disabled && (
          <Stack direction="column" gutterSize={0.25}>
            <FormLabel>{label}</FormLabel>
            <Stack alignY="center" gutterSize={0.5}>
              <KoobButton variant="secondary" asChild>
                <label>
                  {Boolean(forImage) ? t('importImage') : t('chooseFile')}
                  <input
                    type="file"
                    accept={accept}
                    onChange={handleLoadFile}
                    onClick={(e) => {
                      e.target.value = null;
                    }}
                    style={{ display: 'none' }}
                    data-testid={testId}
                  />
                </label>
              </KoobButton>
              {Boolean(value) && (
                <KoobButton type="button" variant="ghost" onClick={handleReset}>
                  <i
                    className="fa-regular fa-trash-can"
                    style={{ fontSize: 24, color: theme.textLighter }}
                  />
                </KoobButton>
              )}
            </Stack>
            {hasError && <ErrorMessageWrapper>{error}</ErrorMessageWrapper>}
          </Stack>
        )}
      </Stack>
    </FormField>
  );
};

export default AvatarField;
